import React from "react";
import { useNavigate } from "react-router-dom";
import { transitionViewIfSupported } from "../utilities";
export default function TransitionLink({ to, href, children, ...props }) {
  const navigate = useNavigate();
  return (
    <a
      href={href}
      onClick={(ev) => {
        if (to) {
          ev.preventDefault();
          transitionViewIfSupported(() => {
            navigate(to);
          });
        }
      }}
      {...props}
    >
      {children}
    </a>
  );
}
